import { runInRestrictedEnvironment } from "../../../../shared/utils/executor"

export const JavascriptSnippetComponent = ({ value, sources }) => {
  return runInRestrictedEnvironment(value, sources)
}
